import { RootState } from '@/index';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CLSTAG, CockpitMode, IssueStatus, IssueType } from '@/utils/constant';
import classNames from 'classnames';
import DiscardIssueModal from '@/components/DiscardIssueModal';
import { clstagStr } from '@/utils/util';
const DiscardIssue = (props: { vehicleName: string; disabled: boolean }) => {
  const [open, setOpen] = useState(false);
  const { vehicleName, disabled } = props;
  const { cockpitMode } = useSelector((state: RootState) => state.cockpitInfo);
  const { issueList } = useSelector((state: RootState) => state.workOrder);
  const issueInfo =
    issueList &&
    issueList.find((workOrder: any) => {
      return (
        workOrder.vehicleName === vehicleName &&
        workOrder.issueType === IssueType.OPS
      );
    });
  const usable =
    (issueInfo?.issueStatus === IssueStatus.PROCESS ||
      issueInfo?.issueStatus === IssueStatus.ON_HOLD) &&
    cockpitMode !== CockpitMode.MONITOR &&
    !disabled &&
    issueInfo?.issueType !== IssueType.PROBLEM_REPORT;

  return (
    <>
      <div
        className={classNames('', {
          'mini-item': usable,
          'mini-item-disabled': !usable,
        })}
        onClick={() => {
          usable && setOpen(true);
        }}
        clstag={clstagStr(CLSTAG.DiscardIssue)}
      >
        <div
          className={classNames('', {
            'operate-discard': usable,
            'operate-discard-disabled': !usable,
          })}
        />

        <h3 className='operate_key'>抛单</h3>
      </div>
      <DiscardIssueModal
        open={open}
        setOpen={setOpen}
        vehicleName={vehicleName}
      />
    </>
  );
};
export default React.memo(DiscardIssue);
